import initialState from './initialState';

export function batchProcessListHasErrored(
  state = initialState.batchProcessListHasErrored,
  action,
) {
  switch (action.type) {
    case 'BATCH_PROCESS_LIST_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function batchProcessListIsRunning(
  state = initialState.batchProcessListIsRunning,
  action,
) {
  switch (action.type) {
    case 'BATCH_PROCESS_LIST_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function batchProcessListSuccess(
  state = initialState.batchProcessListSuccess,
  action,
) {
  switch (action.type) {
    case 'BATCH_PROCESS_LIST_SUCCESS':
      return action.items;
    default:
      return state;
  }
}

export function runBatchProcessHasErrored(
  state = initialState.runBatchProcessHasErrored,
  action,
) {
  switch (action.type) {
    case 'RUN_BATCH_PROCESS_HAS_ERRORED':
      return {
        isBatchErrored: action.hasErrored,
        errorMessage: action.message,
      };
    default:
      return state;
  }
}

export function runBatchProcessIsRunning(
  state = initialState.runBatchProcessIsRunning,
  action,
) {
  switch (action.type) {
    case 'RUN_BATCH_PROCESS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function runBatchProcessSuccess(
  state = initialState.runBatchProcessSuccess,
  action,
) {
  switch (action.type) {
    case 'RUN_BATCH_PROCESS_SUCCESS':
      return action.items;
    default:
      return state;
  }
}

export function rollbackBatchProcessHasErrored(
  state = initialState.rollbackBatchProcessHasErrored,
  action,
) {
  switch (action.type) {
    case 'ROLLBACK_BATCH_PROCESS_HAS_ERRORED':
      return {
        isBatchErrored: action.hasErrored,
        errorMessage: action.message,
      };
    default:
      return state;
  }
}

export function rollbackBatchProcessIsRunning(
  state = initialState.rollbackBatchProcessIsRunning,
  action,
) {
  switch (action.type) {
    case 'ROLLBACK_BATCH_PROCESS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function rollbackBatchProcessSuccess(
  state = initialState.rollbackBatchProcessSuccess,
  action,
) {
  switch (action.type) {
    case 'ROLLBACK_BATCH_PROCESS_SUCCESS':
      return action.items;
    default:
      return state;
  }
}
